export default {
    'statistic-type': 'نوع الإحصائية',
    'final-accounts': 'الحسابات الختامية',
    'custom-statements': 'كشوف مخصصة',
    'accounts-summary': 'ملخص حسابات',
    'earnings-and-loss-chart': 'مخطط أرباح و خسائر'
}